export const SET_SOCKET_HELP_REQUESTS = 'SET_SOCKET_HELP_REQUESTS'
export const SET_HELP_REQUESTS = 'SET_HELP_REQUESTS'
export const ADD_HELP_REQUEST = 'ADD_HELP_REQUEST'
export const SET_SELECTED_REQUEST = 'SET_SELECTED_REQUEST'
export const UNSET_SELECTED_REQUEST = 'UNSET_SELECTED_REQUEST'
export const OPEN_DIALOG_REQUEST_DETAILS = 'OPEN_DIALOG_REQUEST_DETAILS'
export const CLOSE_DIALOG_REQUEST_DETAILS = 'CLOSE_DIALOG_REQUEST_DETAILS'
export const UPDATE_HELP_REQUEST = 'UPDATE_HELP_REQUEST'
export const SHOW_FEEDBACK_HELP_REQUESTS = 'SHOW_FEEDBACK_HELP_REQUESTS'
export const HIDE_FEEDBACK_HELP_REQUESTS = 'HIDE_FEEDBACK_HELP_REQUESTS'